import { render } from "./GymSessionTab.vue?vue&type=template&id=bffcae2c&scoped=true"
import script from "./GymSessionTab.vue?vue&type=script&lang=js"
export * from "./GymSessionTab.vue?vue&type=script&lang=js"

import "./GymSessionTab.vue?vue&type=style&index=0&id=bffcae2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffcae2c"]])

export default __exports__